import React from 'react';

interface FieldLabelProps {
  children: React.ReactNode;
  required?: boolean;
  htmlFor?: string;
  className?: string;
  style?: React.CSSProperties;
}

const FieldLabel = ({
  required = false,
  htmlFor,
  className = '',
  style,
  children,
}: FieldLabelProps) => {
  const classes = [
    'input-label',
    required ? 'input-label--required' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <label className={classes} htmlFor={htmlFor} style={style}>
      {children}
    </label>
  );
};

export default FieldLabel;
